module.exports = __webpack_public_path__ + "img/quick-start-guide_en.aa9bf985.jpg";